const device = {
  XS: `(max-width: 560px)`,
  S: `(max-width: 720px)`,
  M: `(max-width: 920px)`,
  L: `(max-width: 1130px)`,
  XL: `(max-width: 1320px)`,
};

export default device;
